import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';

import { AllAmenitiesViewModel, HighlightAmenitiesViewModel, PropertyInfoSectionViewModel } from 'models';

import { Amenities } from 'components/infosite/property-details/amenities';

interface HotelAmenitiesProps {
  amenities: AllAmenitiesViewModel;
  highlightAmenities: HighlightAmenitiesViewModel[];
  propertyAmenities: PropertyInfoSectionViewModel;
  header: string;
}

const HotelAmenities: React.FunctionComponent<HotelAmenitiesProps> = ({ amenities, highlightAmenities, propertyAmenities, header }) => (
  <section>
    <h2 className="is-visually-hidden">
      <LocalizedText message={header} />
    </h2>
    <ErrorBoundary label="hotel.information.details.amenities">
      <Amenities carouselAmenities={amenities.topSummary} highlightAmenities={highlightAmenities} propertyAmenities={propertyAmenities} />
    </ErrorBoundary>
  </section>
);

export { HotelAmenities };
